import { useAuthorizedQuery } from "../api/authorized-query";
import { seedgreenAPI } from "../api/axios";
import { LotDTO } from "../dtos/LotDTO";
import { STALE_TIME_MEDIUM } from "../query/query.constants";
import { useQuery, useQueryClient } from "@tanstack/vue-query";
const LOT_STALE_TIME = STALE_TIME_MEDIUM;
export function useLots() {
    const query = useQuery({
        enabled: useAuthorizedQuery(),
        queryKey: ["lots"],
        queryFn: async () => (await seedgreenAPI.get("v2/Lot")).data,
        staleTime: LOT_STALE_TIME,
        select: (data) => {
            try {
                return (data?.map((lot) => new LotDTO(lot)) ?? []);
            }
            catch (error) {
                console.error("query/lots select ERROR", error);
            }
        },
    });
    return {
        lots: query.data,
        ...query,
    };
}
export function useLot(id) {
    const queryClient = useQueryClient();
    const query = useQuery({
        enabled: useAuthorizedQuery(),
        queryKey: ["lot", id],
        queryFn: async () => {
            if (!id.value) {
                return null;
            }
            return (await seedgreenAPI.get(`v2/Lot/${id.value}`)).data;
        },
        staleTime: LOT_STALE_TIME,
        select: (data) => {
            try {
                return new LotDTO(data);
            }
            catch (error) {
                console.error("query/lot select ERROR", error);
            }
        },
        initialData: () => {
            // Search through the existing "lot" queries, and look to see if we
            // already have this lot loaded in one of them
            const queries = queryClient.getQueriesData({ queryKey: ["lots"] });
            for (const [_queryKey, data] of queries) {
                if (Array.isArray(data)) {
                    const existingData = data.find((l) => l.id === id.value);
                    if (existingData)
                        return existingData;
                }
            }
        },
    });
    return {
        lot: query.data,
        ...query,
    };
}
